import { Application } from "@hotwired/stimulus";
import { registerControllers } from 'stimulus-vite-helpers';

const application = Application.start();

const controllers = import.meta.glob('~/controllers/\*_controller.js', { eager: true });
registerControllers(application, controllers);

window.Stimulus = application;

import '@hotwired/turbo-rails';
import '@popperjs/core';
import Rails from '@rails/ujs';
import $ from 'jquery';
import 'bootstrap';
import Chart from 'chart.js/auto';
import autoComplete from '@tarekraafat/autocomplete.js';

window.Chart = Chart;
window.$ = $;
window.jQuery = $;
window.autoComplete = autoComplete;

Rails.start();

// Add CSRF token to all AJAX requests
const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
if (csrfToken) {
  $.ajaxSetup({
    headers: { 'X-CSRF-Token': csrfToken }
  });
}

// Import project JS.
import { connection_setup_filtering, add_event_listener_cs } from '~/javascripts/connection_setups';
import '~/javascripts/dashboards/building_distribution_by_integration_type';
import '~/javascripts/dashboards/unit_distribution_by_integration_type';
import '~/javascripts/dashboards/integrations_by_month';
import { initialize_datatables } from '~/javascripts/datatables';
import { initializeAutocomplete, fadeFetchButton, closeAlerts } from '~/javascripts/fetch_tenant_list_steped_controller';
import '~/javascripts/fix_position';
import '~/javascripts/flash_messages';
import '~/javascripts/google_workspace_integration';
import { add_unit_on_click, remove_unit_on_click } from '~/javascripts/integrations';
import '~/javascripts/long_content_toggle';
import '~/javascripts/modals';
import '~/javascripts/properties';
import '~/javascripts/property_profile';
import '~/javascripts/real_page_subscriptions';
import '~/javascripts/sidebar';
import { add_units_event_listeners } from '~/javascripts/units';

document.addEventListener('turbo:load', () => {
  if (/integrations/.test(window.location.href)) {
    add_unit_on_click('units-button');
    remove_unit_on_click('units-remove-button');
    add_event_listener_cs();
  } else if (/connection_setups\/[0-9]+\//.test(window.location.href)) {
    connection_setup_filtering();
  } else if (/connection_setups/.test(window.location.href)) {
    connection_setup_filtering();
  } else if (/units/.test(window.location.href)) {
    add_units_event_listeners();
  } else if (/property_tenant_lists_fetch/.test(window.location.href)) {
    initialize_datatables('#tenant_list_table');
  } else if (/\/fetch_tenant_list_stepped\/select_connection_setup/.test(window.location.href)) {
    initializeAutocomplete('connection-setups-list');
    fadeFetchButton('Continue');
  } else if (/\/fetch_tenant_list_stepped\/input_external_id/.test(window.location.href)) {
    initializeAutocomplete('properties-list');
  } else if (/\/fetch_tenant_list_stepped\/fetch/.test(window.location.href)) {
    initialize_datatables('#tenant_list_table');
    closeAlerts();
  } else if (/\/fetch_tenant_list_stepped\/select_occupant_filter/.test(window.location.href)) {
    fadeFetchButton('Fetch');
  } else if (/\/snapshots/.test(window.location.href)) {
    initialize_datatables('#tenant_list_table', {
      hideDownloadButton: true,
      searchPosition: 'topLeft'
    });
  }
});
